"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickChatButton = QuickChatButton;
/* eslint-disable react/jsx-no-bind */
const React = __importStar(require("react"));
const react_jss_1 = require("react-jss");
const react_redux_1 = require("react-redux");
const models_1 = require("@creature-chess/models");
const useStyles = (0, react_jss_1.createUseStyles)({
    button: {
        "fontSize": "1em",
        "@media (orientation: portrait) and (min-width: 431px)": {
            gap: "32px",
            padding: "12px 24px",
            fontSize: "1.5em",
        },
    },
});
function QuickChatButton({ chatOption, sendingPlayerId, }) {
    const styles = useStyles();
    const dispatch = (0, react_redux_1.useDispatch)();
    const onClick = () => {
        dispatch((0, models_1.quickChatPlayerAction)({ sendingPlayerId, chatValue: chatOption }));
    };
    return (React.createElement("button", { onClick: onClick, className: styles.button }, chatOption.toString()));
}
